import styled from 'styled-components';

// Medidas do protótipo: card com cabeçalho, grade de 2 colunas (rótulo em cima, valor embaixo).
export const Container = styled.div`
  .proposal-company-selector select {
    max-width: 480px;
  }

  .edit-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 32px;
  }

  .edit-grid-wide {
    grid-column: 1 / -1;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: #21354a;

    input.form-control {
      min-height: 38px;
      border: 1px solid #ced4da;
      border-radius: 4px;
      padding: 7px 10px;
      font-size: 14px;
      font-weight: 400;
      color: #212529;

      &:focus {
        border-color: #80bdff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
      }
    }
  }

  .form-card {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: #fff;
    padding: 16px 20px;
    margin-bottom: 16px;
  }

  .section-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h2 {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #21354a;
    }

    .material-icons-outlined {
      font-size: 20px;
    }
  }

  .company-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 32px;

    > div small {
      display: block;
      font-size: 13px;
      color: #6c757d;
    }

    > div strong {
      display: block;
      font-weight: 500;
      color: #21354a;
      word-break: break-word;
    }
  }

  .company-subtitle {
    grid-column: 1 / -1;
    border-top: 1px solid #e9ecef;
    padding-top: 14px;
    margin: 0;
    color: #21354a;
    font-size: 16px;
    font-weight: 600;
  }

  .optional-hint {
    margin-left: 8px;
    font-size: 13px;
    font-weight: 400;
    color: #6c757d;
  }

  .badge-preencher {
    display: inline-flex;
    align-items: center;
    border-radius: 4px;
    padding: 3px 7px;
    font-size: 12px;
    font-weight: 600;
    background: #fff3cd;
    color: #856404;
  }

  .empty-optional {
    color: #6c757d;
  }

  .proposal-company-confirm {
    border-top: 1px solid #e9ecef;
    margin: 16px 0 0;
    padding-top: 14px;
    font-weight: 500;
    color: #21354a;
    cursor: pointer;
  }
`;
